import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Attachment01 = function Attachment01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m21.1525 10.8995-9.0156 9.0156c-2.0503 2.0502-5.3744 2.0502-7.4246 0-2.0503-2.0503-2.0503-5.3744 0-7.4247l9.0156-9.0156c1.3668-1.3668 3.5829-1.3668 4.9497 0s1.3668 3.583 0 4.9498l-8.662 8.662c-.6835.6835-1.7915.6835-2.475 0-.6833-.6834-.6833-1.7914 0-2.4748l7.6015-7.6014"
    })
  }));
};
export default Attachment01;